import { render, staticRenderFns } from "./description-edit.vue?vue&type=template&id=b137ad9e&scoped=true"
import script from "./description-edit.vue?vue&type=script&lang=js"
export * from "./description-edit.vue?vue&type=script&lang=js"
import style0 from "./description-edit.vue?vue&type=style&index=0&id=b137ad9e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b137ad9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b137ad9e')) {
      api.createRecord('b137ad9e', component.options)
    } else {
      api.reload('b137ad9e', component.options)
    }
    module.hot.accept("./description-edit.vue?vue&type=template&id=b137ad9e&scoped=true", function () {
      api.rerender('b137ad9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/description-edit.vue"
export default component.exports